export default "__VITE_ASSET___ats_g6B__"